module.exports = __webpack_public_path__ + "img/bind-email-img.95343c87.png";